var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYenSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.844 69.5L210.787 224H280C293.25 224 304 234.75 304 248S293.25 272 280 272H184V320H280C293.25 320 304 330.75 304 344S293.25 368 280 368H184V456C184 469.25 173.25 480 160 480S136 469.25 136 456V368H40C26.75 368 16 357.25 16 344S26.75 320 40 320H136V272H40C26.75 272 16 261.25 16 248S26.75 224 40 224H109.213L4.156 69.5C-3.297 58.531 -0.453 43.609 10.5 36.156C21.469 28.734 36.391 31.531 43.844 42.5L160 213.312L276.156 42.5C283.609 31.531 298.547 28.719 309.5 36.156C320.453 43.609 323.297 58.531 315.844 69.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYenSign);
export default __webpack_public_path__ + "static/media/yen-sign.37c5d4df32a2bc844a090e00f7601c0f.svg";
export { ForwardRef as ReactComponent };